module.exports = "/images/blue-tick.svg?4b15cfebc7d3e7f4a9fd0c72272627e6";